import { History } from 'history';
import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { scrollToTop } from '../core/Const';
import { ContactFormReview } from '../core/ContactFormReview';
import { RecentBlog } from '../core/RecentBlog';
import { SearchForm } from '../core/SearchForm';
import { CMS } from '../shared/CMSData';
import { HotelBedData, SecurityData } from '../shared/index';
import { isNull } from '../utils/index';
export interface IndexBlogProps extends BaseComponentProps {
    // id: string | number;
    lang: string;
    currency: string;
    data: CMS.CmsBlog;
    pageSize: number;
    history?: History;
    slug: string;
    userLogin?: SecurityData.ApplicationUser  | any;
    wishlistCount: (c: number) => any;
    getHotels: (lang: string, page: number, count: number, filter: HotelBedData.SearchFilter, externalFilter: HotelBedData.ExternalFilter) => any;
    initialFilter: HotelBedData.SearchFilter;
}
export interface IndexBlogState extends BaseComponentState {
    data: CMS.CmsBlog;
    hotelDetail?: any;
    page: number;
    hotelCodes: number[];
    responKey?: string;
    hotels: HotelBedData.PagedHotelbedData  | any;
    externalFilter: HotelBedData.ExternalFilter  | any;
    currentFilter: HotelBedData.SearchFilter | any;
    error: boolean;
    errorMessage: string  | any;
    requestingHotels: boolean;
}

export class IndexBlog extends BaseComponent<IndexBlogProps, IndexBlogState> {

    timeout: any = null;

    constructor(props: IndexBlogProps) {

        super(props);
        this.state = {
            data: props.data,
            page: 0,
            hotelCodes: [],
            hotels: null,
            externalFilter: null,
            requestingHotels: true,
            error: false,
            errorMessage: null,
            currentFilter: null,
        };
        scrollToTop();
    }

    componentDidUpdate(prevProps: IndexBlogProps, prevState: IndexBlogState) {
        if (prevProps.slug !== this.props.slug) { scrollToTop(); }
    }

    getCmsContent: (x: any) => any = (x: any) => {
        return { __html: x };
    }

    render() {
        if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
        // console.log("IndexBlog", this.props.data);
        let bgUrl = `url('/uploads/blog/banner/${this.props.data.bannerUrl}')`;
        if (this.props.data.bannerUrl!.substring(0, 4) === 'http') {
            bgUrl = `url('${this.props.data.bannerUrl}')`;
        }
        return (
            <div>

                <div
                    className="swiper-slide"
                    style={{
                        backgroundImage: bgUrl,
                        backgroundSize: 'cover', backgroundPosition: 'center'
                    }
                    }
                >
                    <div className="container home-banner"  > {/**/}
                    </div>
                </div>
                <section className="container-fluid container-fullw bg-white">
                    <div className="container">
                        <div className="col-md-9">
                            <div dangerouslySetInnerHTML={this.getCmsContent(this.props.data.description)} />
                        </div>
                        <div className="col-md-3">
                            <h3>Search Hotel</h3>
                            <SearchForm
                                lang={this.props.lang}
                                showtitle={false}
                                style='vertical'
                                count={15}
                                getHotels={this.props.getHotels}
                                externalFilter={{}}
                                filter={this.props.initialFilter}
                                /* key={btoa(JSON.stringify(this.props.initialFilter))} */
                            />
                            <RecentBlog lang={this.props.lang} />
                        </div>
                    </div>
                    <div className="container" style={{ marginTop: 30 }}>
                        <div className="col-md-9">
                            <h4>Leave a Reply</h4>
                            <p>Your email address will not be published. Required fields are marked *</p>
                            <ContactFormReview from={this.props.slug} lang={this.props.lang} userLogin={this.props.userLogin} userId={isNull(this.props.userLogin) ? 0 : this.props.userLogin.id} />
                        </div>
                    </div>
                </section>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/cms/IndexBlog.tsx